"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinningCards = exports.PotWinner = exports.PotKind = exports.Pot = void 0;
require("reflect-metadata");
const class_transformer_1 = require("class-transformer");
const Player_1 = require("./Player");
class Pot {
    constructor(amount, players = [], kind = PotKind.MAIN, winners = []) {
        this.players = [];
        this.winners = [];
        this.amount = amount;
        this.players = players;
        this.kind = kind;
        this.winners = winners;
    }
    setWinners(winners) {
        this.winners = winners;
    }
    getPlayerIds() {
        return this.players.reduce((playerIds, player) => {
            playerIds.push(player.getId());
            return playerIds;
        }, []);
    }
}
__decorate([
    class_transformer_1.Type(() => Player_1.Player),
    __metadata("design:type", Array)
], Pot.prototype, "players", void 0);
__decorate([
    class_transformer_1.Type(() => PotWinner),
    __metadata("design:type", Array)
], Pot.prototype, "winners", void 0);
__decorate([
    class_transformer_1.Transform(({ value }) => PotKind[value.toUpperCase()]),
    __metadata("design:type", String)
], Pot.prototype, "kind", void 0);
exports.Pot = Pot;
class WinningCards {
    constructor(rank, suit, value, wildValue) {
        this.rank = rank;
        this.suit = suit;
        this.value = value;
        this.wildValue = wildValue;
    }
}
exports.WinningCards = WinningCards;
class PotWinner {
    constructor(playerId, playerName, cards, chipsWon, kind, rankedHandName, rankedHandDescription, winningCards, userId) {
        this.cards = [];
        this.winningCards = [];
        this.playerId = playerId;
        this.playerName = playerName;
        this.cards = cards !== null && cards !== void 0 ? cards : [];
        this.chipsWon = chipsWon;
        this.rankedHandName = rankedHandName;
        this.rankedHandDescription = rankedHandDescription;
        this.winningCards = winningCards;
        this.kind = kind;
        this.potKind = kind;
        this.userId = userId;
    }
}
__decorate([
    class_transformer_1.Type(() => String),
    __metadata("design:type", Array)
], PotWinner.prototype, "cards", void 0);
__decorate([
    class_transformer_1.Transform(({ value }) => PotKind[value.toUpperCase()]),
    __metadata("design:type", String)
], PotWinner.prototype, "kind", void 0);
__decorate([
    class_transformer_1.Type(() => WinningCards),
    __metadata("design:type", Array)
], PotWinner.prototype, "winningCards", void 0);
exports.PotWinner = PotWinner;
var PotKind;
(function (PotKind) {
    PotKind["MAIN"] = "MAIN";
    PotKind["SIDE"] = "SIDE";
})(PotKind || (PotKind = {}));
exports.PotKind = PotKind;
//# sourceMappingURL=Pot.js.map